import React, { useState, useEffect } from "react";
import createPlotlyComponent from "react-plotly.js/factory";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowDown, faArrowUp, faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { StatValue } from "../../types/types";
import { date } from "yup";
import { dcRound } from "../../utils/misc";

const Plotly = require('plotly.js-dist');
const Plot = createPlotlyComponent(Plotly);

type StatsProps = {
    metric: string
    description: string,
    loading: boolean,
    data: StatValue | null,
    changeInverted: boolean,
    dateSelected: string | null,
    context?: string
    year?: string
}

const Stats = ({year, context = "field", metric, description, loading, data, changeInverted = false, dateSelected }: StatsProps) => {
    
    /*console.log("A062524 year", year)
    console.log("A080224 context", context)
    console.log("A062524 metric", metric)
    console.log("A062524 description", description)
    console.log("A062524 loading", loading)
    console.log("A080224 data", data)
    console.log("A062524 dateSelected", dateSelected)*/

    const [yMin, setYMin] = useState(0);
    const [yMid, setYMid] = useState(50);
    const [yMax, setYMax] = useState(100);
    //const [year, setYear] = useState("");
    const [incrementUpdate, setIncrementUpdate] = useState(0);

    const [dataPrepped, setDataPrepped] = useState<any>(null);


    useEffect(() => {
        //console.log("072924 data", data)
        if (data && data.data && data.data.values) {
            const min = data.data.min;//Math.min(...data.data.values.map((point: any) => point));
            const max = data.data.max;//Math.max(...data.data.values.map((point: any) => point));
            const mid = (min + max) / 2;
            setYMin(min);
            setYMid(mid);
            setYMax(max);
        
            // Calculate percent values and store in data.data.pctValues
            let pctValues = data.data.values.map((value: any) => {
                //console.log("B080224 value", value);
                //console.log("B080224 min", min);
                //console.log("B080224 max", max);
                //console.log("B080224 ((value - min) / (max - min)) * 100x", ((value - min) / (max - min)) * 100);
                return ((value - min) / (max - min)) * 100;
            });
            let _data = data;
            _data.data.pctValues = context === "l2" ? pctValues : _data.data.values;
            //console.log("072924 _data", _data)
            setDataPrepped(_data);
        
            const getYearFromDates = (dates: string[]) => new Date(dates[0]).getFullYear();
        
            //console.log("072924 data.data.values", data.data.values);
            //console.log("072924 data.data.pctValues", data.data.pctValues);
        
            //setYear(getYearFromDates(data.data.dates).toString());
        }
        setIncrementUpdate(incrementUpdate + 1);
    }, [data]);

  

    useEffect(() => {
        console.log("E061724 incrementUpdate", incrementUpdate)
        console.log("E061724 data", data)
    }, [incrementUpdate]);

    //const showChange = !loading && data ? data.change !== undefined : false;
    /*console.log("D061724 metric", metric)
    console.log("D061724 data", data)
    console.log("D061724 dateSelected", dateSelected)
    console.log("D061724 yMin", yMin)
    console.log("D061724 yMid", yMid)
    console.log("D061724 yMax", yMax)*/

    const shapes = dateSelected ? [{
        type: 'line',
        x0: dateSelected,
        x1: dateSelected,
        y0: 0,
        y1: 1,
        xref: 'x',
        yref: 'paper',
        line: {
            color: '#abe2fb',
            width: 1,
            //dash: 'dash'
        }
    }] : [];

    return (
        <div>
            <dt className="d-flex justify-content-between">
                <div className="d-flex align-items-center">
                    <OverlayTrigger placement="right" delay={{ show: 100, hide: 200 }} overlay={
                        <Tooltip id={`tooltip-${metric}`}>
                            {description}
                        </Tooltip>}
                    >
                        <FontAwesomeIcon icon={faInfoCircle} className="mr-1 text-sm text-muted" style={{ cursor: 'pointer' }} />
                    </OverlayTrigger>
                    <span className="font-weight-light text-capitalize text-xl">{metric}</span>
                </div>

                {/*!loading && data && showChange && data.change && context === 'field' &&
                    <div className={
                        `${data.changeType === 'increase' ?
                            changeInverted ? 'badge-danger' : 'badge-success' :
                            changeInverted ? 'badge-success' : 'badge-danger'} text-sm h-100 px-2 py-1 rounded-lg`
                    }
                    >
                        {data.changeType === 'increase' ? (
                            <FontAwesomeIcon icon={faArrowUp} className="mr-1" />
                        ) : (
                            <FontAwesomeIcon icon={faArrowDown} className="mr-1" />
                        )}
                        {Math.abs(data.change).toFixed(1)}%
                    </div>
                */}
            </dt>
            <dd>
                {loading && <div className="text-muted text-sm mt-2">Loading...</div>}

                {/*!loading && !data && context === 'field' && <div className="text-muted text-sm mt-2">Data not available</div>}

                {!loading && data && context === 'field' &&
                    <div className="align-items-center d-flex justify-content-between mt-2">
                        <div className="align-items-center d-flex">
                            <div className="text-2xl">{data.value.toFixed(1)}</div>
                            {showChange && data.prevValue && <span className="ml-2 text-sm text-muted">from {data.prevValue.toFixed(1)}</span>}
                        </div>
                        <div className="text-muted text-sm">
                            <FontAwesomeIcon icon={faArrowDown} /> {data.min.toFixed(1)} &nbsp; <FontAwesomeIcon icon={faArrowUp} /> {data.max.toFixed(1)}
                        </div>
                    </div>
                */}
                {/*console.log("DDD061724 data", data)*/}
                {/*console.log("DDD061724 dataPrepped", dataPrepped)*/}
                {/*console.log("DDD061724 year", year)*/}
                {!loading && dataPrepped && dataPrepped.data && dataPrepped.data.values.length > 1 &&
               
                    <div className="mt-2">
                        <Plot
                            key={`${context}-${metric}-${incrementUpdate}`}
                            data={[
                                {
                                    x: dataPrepped.data.dates.map((point: any) => point),
                                    y: dataPrepped.data.pctValues.map((point: any) => point),
                                    type: 'scatter',
                                    mode: 'lines',
                                    line: {
                                        color: 'black',
                                        width: 1,
                                    },
                                    hovertemplate: '%{x|%m/%d}, %{y:.4f}' // Tooltip formatting
                                }
                            ]}
                            layout={{
                                width: context === 'field' ? 245 : context === 'l2' ? 448 : 265,
                                height: 100,
                                margin: { l: (context === 'field' ? 20 : context === 'l2' ? 30 : 20), r: 10, t: 10, b: 10 },
                                shapes: shapes,
                                xaxis: {
                                    type: 'date',
                                    showgrid: false,
                                    zeroline: false,
                                    showline: false,
                                    showticklabels: true,
                                    tickangle: 0,
                                    tickvals: [
                                        `${year}-01-01`, `${year}-02-01`, `${year}-03-01`, `${year}-04-01`, 
                                        `${year}-05-01`, `${year}-06-01`, `${year}-07-01`, `${year}-08-01`, 
                                        `${year}-09-01`, `${year}-10-01`, `${year}-11-01`, `${year}-12-01`
                                    ],
                                    ticktext: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
                                    tickfont: { size: 8 }, // Smaller font for labels
                                    range: [`${year}-01-01`, `${year}-12-31`], // Full year range
                                },
                                yaxis: {
                                    showgrid: true,
                                    zeroline: false,
                                    showline: false,
                                    showticklabels: true,
                                    //tickvals: [yMin, yMid, yMax],
                                    //tickangle: 0, //45, // Keep labels horizontal
                                    //ticktext: [
                                    //            dcRound(yMin, undefined, undefined, true), 
                                    //            dcRound(yMid, undefined, undefined, true), 
                                    //            dcRound(yMax, undefined, undefined, true)
                                    //        ],
                                    tickvals: [0, 50, 100],
                                    tickangle: 0, // Keep labels horizontal
                                    ticktext: ['0', '50', '100'],
                                    tickfont: { size: 8 }, // Smaller font for labels
                                    range: [0, 100],
                                },
                            }}
                            config={{ displayModeBar: false }}
                        />
                    </div>
                }
            </dd>
        </div>
    );
}

export default Stats;
